module.exports = __webpack_public_path__ + "6380c332706d7c828da7edf9eb07d26b.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/head/hat-cowboy.png
// module id = 2721
// module chunks = 0